module.exports = __webpack_public_path__ + "static/img/certif.86256fd8.jpg";